import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpRuntimeIsMultipleOfMonthValidator
     * @memberof app
     *
     * @restrict A
     * @scope false
     *
     * @description
     * If runtime is not the multiple of a month it is invalid
     *
     * @attr {{start: Date, end: Date}} ngModel
     *
     *
     * @author frbomke.btc
     */
    angular
        .module('app')
        .directive(
            'pkpRuntimeIsMultipleOfMonthValidator',
            pkpRuntimeIsMultipleOfMonthValidator
        );

    function pkpRuntimeIsMultipleOfMonthValidator() {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            ngModelCtrl.$validators.pkpRuntimeIsMultipleOfMonthValidator =
                validate;

            function validate(modelValue) {
                if (!modelValue || !modelValue.start) {
                    return true;
                }

                // if (angular.isDefined(attr.startNotInPastValidatorActive)
                //     && !scope.$eval(attr.startNotInPastValidatorActive)) {
                //     return true;
                // }
                //
                // var now = moment();
                // var runtimeStart = moment(modelValue.start);
                //
                // return !runtimeStart.isBefore(now, 'minute');

                function checkIsMultipleOfMonth(interval, isMultipleMonth) {
                    if (
                        typeof interval !== 'undefined' &&
                        typeof isMultipleMonth !== 'undefined' &&
                        isMultipleMonth
                    ) {
                        var start = moment(interval.start);
                        var end = moment(interval.end);

                        var year0 = start.year();
                        var year1 = end.year();

                        var month0 = start.month();
                        var month1 = end.month();

                        var day0 = start.date();
                        var day1 = end.date();

                        return (
                            day0 === 1 &&
                            day1 === 1 &&
                            (month1 - month0 !== 0 || year1 - year0 !== 0)
                        );
                    }

                    return true;
                }

                return checkIsMultipleOfMonth(modelValue, true);
            }
        }
    }
})();
